import { Avatar } from "baseui/avatar";
import useGetAvatarColor from "../../hooks/useGetAvatarColor/useGetAvatarColor";

const ColoredAvatar = (props) => {
    const userColor = useGetAvatarColor(props.username);

    const overrides = { ...props.overrides, ...{
      Root: {
        style: ({ $theme }) => ({
          backgroundColor: userColor
        })
      }
    }}

    return (
      <span title={props.username}>
        <Avatar  name={props.username} {...props} overrides={overrides}></Avatar>
        </span>
    );
}

export default ColoredAvatar